import api from './api';

const couponService = {
    // Get all coupons (Admin)
    getCoupons: async () => {
        const response = await api.get('/coupons');
        return response.data;
    },

    // Create a new coupon (Admin)
    createCoupon: async (couponData) => {
        const response = await api.post('/coupons', couponData);
        return response.data;
    },

    // Redeem a coupon (User)
    redeemCoupon: async (code) => {
        const response = await api.post('/coupons/redeem', { code });
        return response.data;
    }
};

export default couponService;
